import { render, staticRenderFns } from "./initChangePwSso.vue?vue&type=template&id=1c39020e"
import script from "./initChangePwSso.vue?vue&type=script&lang=js"
export * from "./initChangePwSso.vue?vue&type=script&lang=js"
import style0 from "./initChangePwSso.vue?vue&type=style&index=0&id=1c39020e&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c39020e')) {
      api.createRecord('1c39020e', component.options)
    } else {
      api.reload('1c39020e', component.options)
    }
    module.hot.accept("./initChangePwSso.vue?vue&type=template&id=1c39020e", function () {
      api.rerender('1c39020e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/initChangePwSso.vue"
export default component.exports